export const utils = {}

utils.getEntityByType = (entities, param) => {
  let tmpEntity = []
  entities.forEach(entity => {
    const {frontmatter} = entity.node
    if (frontmatter.template === param) {
      entity.node.frontmatter.slug = entity.node.fields.slug
      tmpEntity.push(entity.node.frontmatter)
    }
  })

  return tmpEntity
}

utils.getEntityByKey = (entities, key) => {
  let tmpEntity = {}
  entities.forEach(entity => {
    const { frontmatter } = entity.node
    if (Object.hasOwnProperty.call(frontmatter, key) && frontmatter[key] === 'index-page') {
      tmpEntity = frontmatter
    }
  })

  return tmpEntity
}

utils.getIndexPageEntities = (indexEntities, entities, key) => {
  let tmpEtities = []
  indexEntities.forEach((item) => {
    for (let _key in item) {
      entities.forEach(entity => {
        if (entity[key] === item[_key]) {
          tmpEtities.push(entity)
        }
      })
    }
  })

  return tmpEtities
}

utils.filterVideosByCategory = (categories, videoBlocks, videos) => {
  categories.forEach(category => {
    category.videos = []
    videoBlocks.forEach(block => {
      if (block.category === category.title) {
        block.videos.forEach(item => {
          videos.forEach(video => {
            if (video.url === item.video) {
              category.videos.push(video)
            }
          })
        })
      }
    })
  })

  return categories
}

utils.sortVideosByDate = videos => {
  videos.sort((a, b) => {
    let c = new Date(a.date)
    let d = new Date(b.date)
    return c-d
  })
  return videos
}

utils.sortVideosByCountry = (videos, activeCountry) => {
  if (activeCountry !== '') {
    videos.forEach(video => {
      video.videosToShow = video.videosToShow.filter(item => item.country.toLowerCase() === activeCountry.toLowerCase())
    })
  }
  return videos
}

utils.getVideosByLang = (categories, activeLang) => {
  categories.forEach(category => {
    category.videosToShow = []
    category.videos.forEach(video => {
      if (video.lang.toLowerCase() === activeLang.toLowerCase()) {
        category.videosToShow.push(video)
      }
    })
    if (category.videosToShow.length === 0) {
      category.videos.forEach(video => {
        if (video.lang.toLowerCase() === 'en') {
          category.videosToShow.push(video)
        }
      })
    }
  })
  return categories
}

utils.getActiveVideo = (nodes, videoBloks, params) => {
  const {slug} = params
  videoBloks.forEach(block => {
    block.selectedVideos = []
    block.activeVideo = {}
    block.videos.forEach(({video}) => {
      nodes.forEach(({node}) => {
        if (node.frontmatter.url === video) {
          block.selectedVideos.push(node.frontmatter)
          if (node.fields.slug === slug) {
            block.activeVideo = node.frontmatter
          }
        }
      })
    })
  })

  const activeVideo = videoBloks.filter(({activeVideo}) => activeVideo.slug === slug)[0]

  return activeVideo
}

utils.orderByName = countries => {
  const sorted = countries.sort((a, b) => {
    let c = a.title.toLowerCase()
    let m = b.title.toLowerCase()
    if (c < m) {
      return -1
    } else if (c > m) {
      return 1
    } else {
      return 0
    }
  })
  return sorted
}

utils.getShuffedArr = arr => {
  return [...arr].map((_, i, arrCopy) => {
    var rand = i + ( Math.floor( Math.random() * ( arrCopy.length - i ) ) );
    [arrCopy[rand], arrCopy[i]] = [arrCopy[i], arrCopy[rand]]
    return arrCopy[i]
  })
}